export const BUILD_VERSION = '1783690782';
